export default __webpack_public_path__ + "static/media/gamma-icon.bcdbd75a.png";